export const MULTI_SELECT_VALUE_SEPARATOR: string = ', '
